import { confirm, DialogResponse } from 'owa-confirm-dialog';
import controlStrings from 'owa-strings/owa-common-strings';
import * as React from 'react';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
var IgnoreConversationsConfirmDialog = /** @class */ (function () {
    function IgnoreConversationsConfirmDialog(title, subtext, onConfirm, onDismiss) {
        var _this = this;
        this.title = title;
        this.subtext = subtext;
        this.isChecked = false;
        this.onConfirm = onConfirm;
        this.onDismiss = onDismiss;
        this.dialogOptions = {
            okText: controlStrings.okButton,
            cancelText: controlStrings.cancelButton,
            bodyElement: (React.createElement(Checkbox, { label: 'Do not show this message again', onChange: function () {
                    _this.isChecked = !_this.isChecked;
                } })),
        };
    }
    IgnoreConversationsConfirmDialog.prototype.show = function () {
        var _this = this;
        return confirm(this.title, this.subtext, false, this.dialogOptions).then(function (response) {
            if (response === DialogResponse.ok) {
                return _this.onConfirm(_this.isChecked);
            }
            else {
                return _this.onDismiss();
            }
        });
    };
    return IgnoreConversationsConfirmDialog;
}());
export default IgnoreConversationsConfirmDialog;
//# sourceMappingURL=IgnoreConversationsConfirmDialog.js.map